import { AxiosInstance } from 'axios'
import { IExportResponse } from '../../../types/importExport.types'

export function gamificationExportApiFactory(api: AxiosInstance) {
  const baseUrl = '/api/v1/export/user-scores'

  const methods = {
    getAll() {
      return api.get<IExportResponse[]>(`${baseUrl}`)
    },
    triggerExport(include_deleted: boolean, start_date: string, end_date: string) {
      return api.post<IExportResponse>(baseUrl, {}, {
        params: {
          include_deleted,
          start_date,
          end_date
        }
      })
    },
    getExportStatus(exportId: number) {
      return api.get<IExportResponse>(`${baseUrl}/${exportId}`)
    },
    async getDownloadLink(exportId: number): Promise<string | undefined> {
      return api.get(`${baseUrl}/${exportId}/file`, {
        responseType: 'blob'
      }).then((response) => {
        const blob = new Blob([ response.data ], { type: 'text/csv' })
        return URL.createObjectURL(blob)
      })
    }
  }
  return methods
}
